console.log("Tabletop Goodies - Script - Resources (FR)");

TTG.Resources.Strings.Languages = 
{
   "en": "Anglais",
    "fr": "Français",
     "es": "Espagnol"
}


TTG.Resources.Strings.ColorNames = 
  {
    red: "Rouge",
    dark_red: "Rouge foncé",
    dark_orange: "Orange foncé",
    orange: "Orange",
    yellow: "Jaune",
    beige: "Beige",
    brown: "Marron",
    dark_green: "Vert foncé",
    light_green: "Vert clair",
    green: "Vert",
    light_blue: "Bleu foncé",
    blue : "Bleu",
    dark_blue: "Bleu foncé",
    dark_purple: "Mauve foncé",
    purple: "Mauve",
    magenta: "Magenta",
    pink: "Rose",
    teal: "Sarcelle",
    gray: "Gris",
    dark_gray: "Gris foncé",
    black: "Noir",
    white: "Blanc"
  };